import fetch from "../../components/optionsFetch";
import DashboardChartCard, { DASHBOARD_CHART_OPTIONS, DashboardChartSkeleton, dashboardActionStyle as buttonStaticStyle } from "./DashboardChartCard";
﻿import * as React from "react";
import ReactDOM from "react-dom";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTitle,
    ChartLegend,
    exportVisual,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartSeriesDefaults,
} from "@progress/kendo-react-charts";
import configData from "../../config.json";
import { GetSession, GetToken } from "../../components/Session";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { GetCloudLogin } from "../../WeighBridge/Helpers";





const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 10000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
    },
    content: {
        backgroundColor: "white",
        borderRadius: "8px",
        width: "95vw",
        height: "95vh",
        padding: "20px",
        position: "relative",
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        perspective: "1000px",
    },
    closeBtnTopRight: {
        position: "absolute",
        top: "10px",
        right: "15px",
        fontSize: "28px",
        border: "none",
        background: "none",
        cursor: "pointer",
        color: "#333",
    },
    closeBtnBottom: {
        marginTop: "auto",
        alignSelf: "center",
        padding: "10px 25px",
        fontSize: "16px",
        borderRadius: "5px",
        border: "1px solid #333",
        background: "white",
        cursor: "pointer",
        color: "#333",
        transition: "background-color 0.2s ease",
    },
};

const InventoryTrend = () => {
    const [categories, setCategories] = React.useState([]);
    const [inOut, setInOut] = React.useState(null);
    const [productInventory, setProductInventory] = React.useState(null);
    const [accumulated, setAccumulated] = React.useState(null);
    const [pieData, setPieData] = React.useState(null);
    const [inoutMonths, setInoutMonths] = React.useState([]);
    const [topNProducts, setTopNProducts] = React.useState("Product Inventory");
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState({ id: "0", name: "All" });
    const [products, setProducts] = React.useState([]);
    const [product, setProduct] = React.useState({ id: "0", name: "All" });
    const [modalChart, setModalChart] = React.useState(null);
    const [salesYAxis, setSalesYAxis] = React.useState("");
    const [productYAxis, setProductYAxis] = React.useState("");
    const [accYAxis, setAccYAxis] = React.useState("");
    const [expanded, setExpanded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const sale = React.useRef(null);
    const productChart = React.useRef(null);
    const total = React.useRef(null);
    const pieChart = React.useRef(null);
    const timer = React.useRef(null);
    const cloudToken = React.useRef("");

    React.useEffect(() => {
        GetCloudLogin((cred) => {
            cloudToken.current = cred === "" ? "" : cred.token;
        });

        const init = {
            method: "GET",
            accept: "application/json",
            headers: { Authorization: "Bearer " + GetToken() },
        };

        fetch(configData.SERVER_URL + "apiv7/options", init)
                .then((res) => res.json())
                .then((d) => {
                setSites([{ id: "0", name: "All" }, ...d.sites]);
                setSite({ id: "0", name: "All" });
                setProducts([{ id: "0", name: "All" }, ...d.products]);
                setProduct({ id: "0", name: "All" });
                refreshDashboard(0, 0);
            });
    }, []);

    const getSetting = (settings, name) => {
        if (!settings) return false;
        const st = settings.find((s) => s.name === name);
        if (!st) return undefined;
        let v = String(st.value);
        switch (st.type) {
            case 0:
                return v.toLowerCase() === "true";
            case 1:
                return parseInt(v);
            case 2:
                return parseFloat(v);
            default:
                return v;
        }
    };

    const refreshDashboard = (siteIdVal, productIdVal) => {
        setIsLoading(true);
        const init = {
            method: "GET",
            accept: "application/json",
            headers: {
                Authorization:
                    "Bearer " + (cloudToken.current === "" || cloudToken.current === null ? GetToken() : cloudToken.current),
            },
        };
        const offset = new Date().getTimezoneOffset() / 60;
        const sess = GetSession();
        const baseUrl =
            cloudToken.current && cloudToken.current !== "" ? sess.CloudURL : configData.SERVER_URL;

        fetch(`${baseUrl}apiV7/dashboard/getinventorytrends?site=${siteIdVal}&product=${productIdVal}&offset=${offset}`, init)
                .then((res) => res.json())
                .then((d) => {
                const productNames = d.productNames || [];
                setInOut(d.inOut || []);
                setProductInventory(d.productInventory || []);
                setAccumulated(d.accumulated || []);
                setPieData(d.pieData || []);
                setCategories(productNames);
                setTopNProducts(`Product Inventory (Top ${productNames.length})`);
                setInoutMonths(d.monthNames || []);
                setSalesYAxis(d.salesY || "");
                setProductYAxis(d.productY || "");
                setAccYAxis(d.accY || "");
            })
            .catch(() => {
                setInOut([]);
                setProductInventory([]);
                setAccumulated([]);
                setPieData([]);
                setCategories([]);
                setInoutMonths([]);
            })
            .finally(() => setIsLoading(false));
    };

    const onSiteChange = (e) => {
        setSite(e.target.value);
    };

    const onProductChange = (e) => {
        setProduct(e.target.value);
    };

    const ApplyFilters = () => {
        refreshDashboard(site.id, product.id);
    };

    const ClearFilters = () => {
        const allSite = sites.find((item) => String(item.id) === "0") || { id: "0", name: "All" };
        const allProduct = products.find((item) => String(item.id) === "0") || { id: "0", name: "All" };
        setSite(allSite);
        setProduct(allProduct);
        refreshDashboard(0, 0);
    };

    const onImageExportClick = React.useCallback((e) => {
        let chartVisual = null;
        switch (e.currentTarget.name) {
            case "sales":
                chartVisual = sale.current && exportVisual(sale.current);
                break;
            case "product":
                chartVisual = productChart.current && exportVisual(productChart.current);
                break;
            case "total":
                chartVisual = total.current && exportVisual(total.current);
                break;
            case "pie":
                chartVisual = pieChart.current && exportVisual(pieChart.current);
                break;
            default:
                break;
        }
        if (chartVisual) {
            exportPDF(chartVisual, { paperSize: "A4", landscape: true }).then((dataURI) => saveAs(dataURI, "Inventory.pdf"));
        }
    }, []);

    const ExportZoomButton = ({ name, onClick, iconClass, ariaLabel }) => (
        <button
            type="button"
            name={name}
            onClick={onClick}
            aria-label={ariaLabel}
            style={buttonStaticStyle}
            className="k-button k-button-icon"
        >
            <i className={`fa ${iconClass}`} aria-hidden="true" />
        </button>
    );

    const ButtonsGroup = ({ exportName, onExportClick, onZoomClick }) => (
        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end", marginBottom: 8 }}>
            <ExportZoomButton name={exportName} onClick={onExportClick} iconClass="fa-download" ariaLabel="Export as PDF" />
            <ExportZoomButton onClick={onZoomClick} iconClass="fa-expand" ariaLabel="Expand Chart" />
        </div>
    );

    const renderModalChart = () => {
        if (!modalChart) return null;
        const commonProps = {
            style: {
                height: "85vh",
                width: "100%",
                filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
                borderRadius: "10px",
            },
            transitions: false,
        };
        switch (modalChart) {
            case "sales":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={sale}>
                        <ChartTitle text="Inventory In/Out" font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={inoutMonths || []} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: salesYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="line" />
                        <ChartSeries>
                            {(inOut || []).map((item, idx) => (
                                <ChartSeriesItem key={idx} type="line" tooltip={{ visible: true }} data={item.data} name={item.name} />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "product":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={productChart}>
                        <ChartTitle text={topNProducts} font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={categories || []} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: productYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="column" />
                        <ChartSeries>
                            {(productInventory || []).map((item, idx) => (
                                <ChartSeriesItem key={idx} type="column" tooltip={{ visible: true }} data={item.data} name={item.name} />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "total":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={total}>
                        <ChartTitle text="Inventory Movement" font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={inoutMonths || []} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: accYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="area" />
                        <ChartSeries>
                            {(accumulated || []).map((item, idx) => (
                                <ChartSeriesItem key={idx} type="area" tooltip={{ visible: true }} data={item.data} name={item.name} />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "pie":
                return (
                    <Chart {...DASHBOARD_CHART_OPTIONS} {...commonProps} ref={pieChart}>
                        <ChartTitle text="Stockpile Inventory" font="22Pt bold" color="#00008B" />
                        <ChartLegend position="side" orientation="vertical" />
                        <ChartSeries>
                            <ChartSeriesItem type="column" tooltip={{ visible: true }} data={pieData || []} categoryField="name" field="share" />
                        </ChartSeries>
                    </Chart>
                );
            default:
                return null;
        }
    };

    const dashboardCharts = React.useMemo(() => {
        const showSkeleton = isLoading;

        return (
            <>
                <div className="row mb-3">
                    <div className="col-6">
                        <DashboardChartCard title="Inventory In/Out" icon="fa-chart-line" subtitle="Compares this year's inventory with last year" actions={<ButtonsGroup
                            exportName="sales"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("sales")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={sale} style={{ height: 245 }}>
                                    <ChartLegend position="top" orientation="horizontal" />
                                    <ChartCategoryAxis>
                                        <ChartCategoryAxisItem categories={inoutMonths || []} startAngle={45} />
                                    </ChartCategoryAxis>
                                    <ChartValueAxis>
                                        <ChartValueAxisItem title={{ text: salesYAxis }} />
                                    </ChartValueAxis>
                                    <ChartSeriesDefaults type="line" />
                                    <ChartSeries>
                                        {(inOut || []).map((item, idx) => (
                                            <ChartSeriesItem key={idx} type="line" tooltip={{ visible: true }} data={item.data} name={item.name} />
                                        ))}
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>

                    <div className="col-6">
                        <DashboardChartCard title={topNProducts} icon="fa-cube" subtitle="Current stock compared with this time last year" actions={<ButtonsGroup
                            exportName="product"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("product")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={productChart} style={{ height: 245 }}>
                                    <ChartLegend position="top" orientation="horizontal" />
                                    <ChartCategoryAxis>
                                        <ChartCategoryAxisItem categories={categories || []} startAngle={45} />
                                    </ChartCategoryAxis>
                                    <ChartValueAxis>
                                        <ChartValueAxisItem title={{ text: productYAxis }} />
                                    </ChartValueAxis>
                                    <ChartSeriesDefaults type="column" />
                                    <ChartSeries>
                                        {(productInventory || []).map((item, idx) => (
                                            <ChartSeriesItem key={idx} type="column" tooltip={{ visible: true }} data={item.data} name={item.name} />
                                        ))}
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <DashboardChartCard title="Inventory Movement" icon="fa-arrow-trend-up" subtitle="Monthly IN and OUT movement for this year and last year" actions={<ButtonsGroup
                            exportName="total"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("total")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={total} style={{ height: 245 }}>
                                    <ChartLegend position="top" orientation="horizontal" />
                                    <ChartCategoryAxis>
                                        <ChartCategoryAxisItem categories={inoutMonths || []} startAngle={45} />
                                    </ChartCategoryAxis>
                                    <ChartValueAxis>
                                        <ChartValueAxisItem title={{ text: accYAxis }} />
                                    </ChartValueAxis>
                                    <ChartSeriesDefaults type="area" />
                                    <ChartSeries>
                                        {(accumulated || []).map((item, idx) => (
                                            <ChartSeriesItem key={idx} type="area" tooltip={{ visible: true }} data={item.data} name={item.name} />
                                        ))}
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>

                    <div className="col-6">
                        <DashboardChartCard title="Stockpile Inventory" icon="fa-location-dot" subtitle="Current stockpile inventory" actions={<ButtonsGroup
                            exportName="pie"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("pie")}
                        />}>
                            {showSkeleton ? <DashboardChartSkeleton /> : (
                                <Chart {...DASHBOARD_CHART_OPTIONS} ref={pieChart} style={{ height: 245 }}>
                                    <ChartLegend position="side" orientation="vertical" />
                                    <ChartSeries>
                                        <ChartSeriesItem type="column" tooltip={{ visible: true }} data={pieData || []} categoryField="name" field="share" />
                                    </ChartSeries>
                                </Chart>
                            )}
                        </DashboardChartCard>
                    </div>
                </div>
            </>
        );
    }, [isLoading, inOut, inoutMonths, salesYAxis, productInventory, topNProducts, categories, productYAxis, accumulated, accYAxis, pieData, onImageExportClick]);

    return (
        <>
            <ExpansionPanel
                className="wm-advanced-search wm-advanced-search--kendo wm-dashboard-advanced-search"
                title="Advanced Search"
                expandIcon="fa fa-plus"
                collapseIcon="fa fa-minus"
                expanded={expanded}
                onAction={(event) => setExpanded(!event.expanded)}
            >
                <Reveal>
                    {expanded && (
                        <ExpansionPanelContent>
                            <div className="wm-advanced-search__fields">
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="InventorySite">Site</label>
                                    <DropDownList id="InventorySite" data={sites} value={site} textField="name" dataItemKey="id" onChange={onSiteChange} popupSettings={{ width: "auto" }} />
                                </div>
                                <div className="wm-advanced-search__field">
                                    <label htmlFor="InventoryProduct">Product</label>
                                    <DropDownList id="InventoryProduct" data={products} value={product} textField="name" dataItemKey="id" onChange={onProductChange} popupSettings={{ width: "auto" }} />
                                </div>
                                <div className="wm-advanced-search__actions">
                                    <Button onClick={ApplyFilters} themeColor="primary" icon="search">Apply</Button>
                                    <Button onClick={ClearFilters} icon="reset">Clear</Button>
                                </div>
                            </div>
                        </ExpansionPanelContent>
                    )}
                </Reveal>
            </ExpansionPanel>

            {dashboardCharts}

            {modalChart &&
                ReactDOM.createPortal(
                    <div style={modalStyles.overlay} onClick={() => setModalChart(null)}>
                        <div style={modalStyles.content} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
                            <button style={modalStyles.closeBtnTopRight} aria-label="Close" onClick={() => setModalChart(null)}>
                                &times;
                            </button>
                            {renderModalChart()}
                            <button style={modalStyles.closeBtnBottom} onClick={() => setModalChart(null)}>
                                Close
                            </button>
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
};

export default InventoryTrend;



